module.exports = __webpack_public_path__ + "static/media/siddharth-amaravati-trip-18.baabb7eb.png";